import React, { Component } from "react";
import { Link } from "react-router-dom";

// Images
import bg1 from "../../images/background/bg1.png";
import pic1 from "../../images/about/pic1.jpg";
import { telefon } from "../../utils/constants";

class AboutUsOneSection extends Component {
  render() {
    return (
      <>
        <section
          className="section-area section-sp1 bg-white"
          style={{ backgroundImage: "url(" + bg1 + ")", backgroundRepeat: "no-repeat" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 mb-40">
                <div className="heading-bx mb-4">
                  <h1 className="title h3">OM KUNGÄLV BILSKADECENTER</h1>
                  <p>
                    Vi tar hand om din bil Kungälv Bilskadecenter är en bilverkstad med lång erfarenhet och ett starkt
                    engagemang för kvalitet. Vi är stolta över att erbjuda en personlig och professionell service där
                    varje kund står i centrum.
                  </p>
                  <h2 className="h4">Vår historia:</h2>
                  <p>
                    Sedan starten har vårt mål varit att skapa en verkstad som levererar både högkvalitativ service och
                    en förstklassig kundupplevelse. Vi har byggt vårt rykte genom hårt arbete, pålitlighet och fokus på
                    detaljer.
                  </p>
                  <h2 className="h4">Vårt team:</h2>
                  <p>
                    Våra tekniker är erfarna och certifierade inom allt från service och reparation till avancerade
                    skadereparationer och lackering. Med regelbunden utbildning och uppdateringar om den senaste
                    tekniken är vi alltid redo att ta oss an nya utmaningar.
                  </p>
                </div>
              </div>
              <div className="col-lg-7 mb-30">
                <div className="about-media">
                  <div className="media">
                    <img src={pic1} alt="Kungälv Bilskadecenter - Modern bilverkstad med expertteam" />
                  </div>
                  <div className="about-contact bg-primary text-white">
                    <h6 className="title-ext text-white">WANT TO TALK?</h6>
                    <h3 className="number mb-15 text-white">{telefon}</h3>
                    <p className="mb-20">
                      Behöver du en särskild reparationsservice? Vi är glada att uppfylla varje önskemål för att
                      överträffa dina förväntningar.
                    </p>
                    <Link to="/kontakta-oss" className="btn btn-light">
                      BOKA EN TID
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-5">
                <h3 className="h5">Våra lokaler:</h3>
                <p>
                  Vår moderna verkstad är utrustad med den senaste tekniken för att säkerställa snabb och effektiv
                  service. Vi erbjuder bekväma väntrum för våra kunder, och om du behöver en lånebil under reparationen,
                  löser vi det också.
                </p>
              </div>
              <div className="col-1"></div>
              <div className="col-5">
                <h3 className="h5">Hör av dig till oss:</h3>
                <p>
                  Har du frågor eller funderingar? Tveka inte att kontakta oss. Vi finns här för att hjälpa dig med allt
                  från prisförslag till skadebesiktning, och vi ser fram emot att assistera dig med professionell
                  rådgivning och högkvalitativ service.
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default AboutUsOneSection;
